import { render, staticRenderFns } from "./custom_table.vue?vue&type=template&id=4c4e2ccb&scoped=true"
import script from "./custom_table.vue?vue&type=script&lang=js"
export * from "./custom_table.vue?vue&type=script&lang=js"
import style0 from "./custom_table.vue?vue&type=style&index=0&id=4c4e2ccb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4e2ccb",
  null
  
)

export default component.exports